var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataBubblesChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 100,
    viewBox: "0 0 177 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.447,
    cy: 26.2785,
    r: 10.7347,
    fill: "#F6F6F6",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.4339,
    cy: 33.8967,
    r: 7.96446,
    fill: "#F6F6F6",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.9645,
    cy: 41.9645,
    r: 7.96446,
    fill: "#F6F6F6",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.8999,
    cy: 13.1198,
    r: 12.1198,
    fill: "#F6F6F6",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5405,
    cy: 79.2595,
    r: 5.5405,
    fill: "#F6F6F6",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5405,
    cy: 64.0231,
    r: 5.5405,
    fill: "#F6F6F6",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.4339,
    cy: 56.7512,
    r: 7.96446,
    fill: "#F6F6F6",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9645,
    cy: 73.9645,
    r: 7.96446,
    fill: "#F6F6F6",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 98.5H176.5",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 99L2 1",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataBubblesChart);
export default __webpack_public_path__ + "static/media/no-data-bubbles-chart.8b96e611c890cb1da4b849e6823a99d1.svg";
export { ForwardRef as ReactComponent };